import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmePipesModule } from '../../../../vme-pipes.module';
import { VmeCommonModule } from '../../../../vme-common.module';
import { ICallStateData } from '../../../../interfaces/telephony/call-state.data';
import { getCallStatusText } from '../call-utils';

@Component({
  selector: 'app-call-info-box',
  standalone: true,
  imports: [CommonModule, VmePipesModule, VmeCommonModule],
  templateUrl: './call-info-box.component.html',
  styleUrls: ['./call-info-box.component.scss'],
})
export class CallInfoBoxComponent implements OnInit {
  @Input() call: ICallStateData;
  constructor() {}

  ngOnInit(): void {}

  protected readonly getCallStatusText = getCallStatusText;
}
